import React from "react";
import {
  Table, TableHead, TableRow, TableCell, TableBody, Box,
  IconButton, Button
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router";
import { useTestProcedure } from "../../context/TestProcedureContext.tsx";
import { useSoftwareDesignFiles } from "../../hooks/useSoftwareDesignFiles.ts";
import { useElectronicsConfiguration } from "../../context/ElectronicsConfigurationContext.tsx";
import { isProcedureValid } from "../../utils/testProcedureValidation.ts";
import { useTheme } from "@mui/material";
import PageLayout from '../../components/PageLayout.tsx';


const TestProceduresPage: React.FC = () => {
  const { procedures, addProcedure, removeProcedure } = useTestProcedure();
  const { getSoftwareDesignFiles } = useSoftwareDesignFiles();
  const { config: electronicsConfig } = useElectronicsConfiguration();
  const navigate = useNavigate();
  const theme = useTheme();
  
  const handleEdit = (id: string) => {
      navigate(`/testprocedure/${id}`);
    };

  const handleAdd = () => {
    const id = addProcedure("Prüfablauf " + (procedures.length + 1));
    handleEdit(id);
  };

  const handleDelete = (id: string) => {
    removeProcedure(id);
  };

  return (
    <PageLayout
      title="Prüfabläufe"
      backText="Zurück zur Elektronik"
      backTarget="/electronics"
      nextText="Weiter zur Zusammenfassung"
      nextTarget="/summary"
    >
      {procedures?.length > 0 && (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Anzahl Schritte</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {procedures.map((item) => {
            const valid = isProcedureValid(item, electronicsConfig);
            return (
            <TableRow 
              key={item.id} 
              sx={{
                border: valid ? '1px solid transparent' : '1px solid red',
                backgroundColor: valid ? "inherit" : theme.palette.error.main + "22",
            }}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.steps.length}</TableCell>
              <TableCell align="right">
                <IconButton size="small" color="primary" onClick={() => handleEdit(item.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton size="small" color="error" onClick={() => handleDelete(item.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
            );
          })}
        </TableBody>
      </Table>
      )}
      <Box mt={2} display="flex" gap={2}>
        <Button variant="contained" onClick={handleAdd}>
          Hinzufügen
        </Button>
        <Button variant="outlined" disabled={procedures?.length === 0}   onClick={() => getSoftwareDesignFiles()}>
          Download Prüfabläufe
        </Button>
      </Box>
    </PageLayout>
  );
};

export default TestProceduresPage;